import apiClient from './authService'

export const recallQueueService = {
  // Buscar a fila de reconvocação com filtros e paginação
  async getQueue(params = {}) {
    try {
      // Parâmetros padrão
      const defaultParams = {
        page: 1,
        limit: 20,
        offset: 0,
        ...params
      }
      
      const response = await apiClient.get('/api/v1/recall-appointments/recall-queue/', { 
        params: defaultParams 
      })
      return response
    } catch (error) {
      console.error('Erro ao buscar fila de reconvocação:', error)
      throw error
    }
  },

  // Criar uma nova reconvocação na fila
  async createRecall(recallData) {
    try {
      const response = await apiClient.post('/api/v1/recall-appointments/recall-queue/', recallData)
      return response
    } catch (error) {
      console.error('Erro ao criar reconvocação:', error)
      throw error
    }
  },

  // Agendar uma reconvocação
  async scheduleRecall(scheduleData) {
    try {
      const payload = {
        date: scheduleData.date,
        time: scheduleData.time,
        notes: scheduleData.notes
      }
      
      // Só incluir room_id se for fornecido
      if (scheduleData.room_id) {
        payload.room_id = scheduleData.room_id
      }
      
      const response = await apiClient.post(`/api/v1/recall-appointments/recall-queue/${scheduleData.recall_id}/schedule/`, payload)
      return response
    } catch (error) {
      console.error('Erro ao agendar reconvocação:', error)
      throw error
    }
  },

  // Cancelar uma reconvocação
  async cancelRecall(recallId, reason = '') {
    try {
      const response = await apiClient.post(`/api/v1/recall-appointments/recall-queue/${recallId}/cancel/`, {
        reason: reason
      })
      return response
    } catch (error) {
      console.error('Erro ao cancelar reconvocação:', error)
      throw error
    }
  },

  // Marcar como concluída
  async completeRecall(recallId, notes = '') {
    try {
      const response = await apiClient.post(`/api/v1/recall-appointments/recall-queue/${recallId}/complete/`, {
        notes: notes
      })
      return response
    } catch (error) {
      console.error('Erro ao concluir reconvocação:', error)
      throw error
    }
  },

  // Buscar detalhes de uma reconvocação específica
  async getRecallDetails(recallId) {
    try {
      const response = await apiClient.get(`/api/v1/recall-appointments/recall-queue/${recallId}/`)
      return response
    } catch (error) {
      console.error('Erro ao buscar detalhes da reconvocação:', error)
      throw error
    }
  },

  // Buscar estatísticas da fila
  async getQueueStats() {
    try {
      const response = await apiClient.get('/api/v1/recall-appointments/recall-queue/stats/')
      return response
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error)
      throw error
    }
  },

  // Buscar horários disponíveis para uma data específica
  async getAvailableTimes(date, roomId = null) {
    try {
      const params = { date }
      if (roomId) params.room_id = roomId
      
      const response = await apiClient.get('/api/v1/recall-appointments/recall-queue/available-times/', { params })
      return response
    } catch (error) {
      console.error('Erro ao buscar horários disponíveis:', error)
      throw error
    }
  },

  // Buscar horários disponíveis para uma reconvocação específica
  async getRecallAvailableTimes(recallId, date) {
    try {
      const response = await apiClient.get(`/api/v1/recall-appointments/recall-queue/${recallId}/available-times/`, { 
        params: { date } 
      })
      return response
    } catch (error) {
      console.error('Erro ao buscar horários disponíveis para reconvocação:', error)
      throw error
    }
  },

  // Buscar salas disponíveis
  async getAvailableRooms() {
    try {
      const response = await apiClient.get('/api/v1/recall-appointments/recall-queue/available-rooms/')
      return response
    } catch (error) {
      console.error('Erro ao buscar salas disponíveis:', error)
      throw error
    }
  },

  // Filtrar reconvocações
  async filterRecalls(filters) {
    try {
      const response = await apiClient.get('/api/v1/recall-appointments/recall-queue/filter/', { params: filters })
      return response
    } catch (error) {
      console.error('Erro ao filtrar reconvocações:', error)
      throw error
    }
  },

  // Exportar relatório da fila
  async exportQueueReport(filters = {}) {
    try {
      const response = await apiClient.get('/api/v1/recall-appointments/recall-queue/export/', { 
        params: filters,
        responseType: 'blob'
      })
      return response
    } catch (error) {
      console.error('Erro ao exportar relatório:', error)
      throw error
    }
  }
} 